export var palette = {
    pureWhite: 'hsla(210,0%,100%,1)',
    pureWhite05: 'hsla(210,0%,100%,0.05)',
    pureWhite10: 'hsla(210,0%,100%,0.1)',
    pureWhite20: 'hsla(210,0%,100%,0.2)',
    pureWhite34: 'hsla(210,0%,100%,0.34)',
    pureWhite50: 'hsla(210,0%,100%,0.5)',
    pureWhite80: 'hsla(210,0%,100%,0.8)',
    pureBlack: 'hsla(210,0%,0%,1)',
    pureBlack05: 'hsla(210,0%,0%,0.05)',
    pureBlack10: 'hsla(210,0%,0%,0.1)',
    pureBlack20: 'hsla(210,0%,0%,0.2)',
    pureBlack34: 'hsla(210,0%,0%,0.34)',
    pureBlack50: 'hsla(210,0%,0%,0.5)',
    pureBlack80: 'hsla(210,0%,0%,0.8)',
    purple1: 'hsla(262,80%,98%,1)',
    purple2: 'hsla(262,61%,93%,1)',
    purple3: 'hsla(261,68%,84%,1)',
    purple4: 'hsla(261,54%,68%,1)',
    purple5: 'hsla(261,47%,58%,1)',
    purple6: 'hsla(262,43%,51%,1)',
    purple7: 'hsla(262,48%,46%,1)',
    purple8: 'hsla(262,60%,38%,1)',
    purple9: 'hsla(262,69%,31%,1)',
    purple10: 'hsla(262,72%,25%,1)',
    purpleAlt1: 'hsla(262,67%,99%,1)',
    indigo1: 'hsla(236,100%,98%,1)',
    indigo2: 'hsla(237,100%,96%,1)',
    indigo3: 'hsla(239,92%,90%,1)',
    indigo4: 'hsla(238,93%,84%,1)',
    indigo5: 'hsla(240,86%,72%,1)',
    indigo6: 'hsla(241,80%,61%,1)',
    indigo7: 'hsla(244,71%,52%,1)',
    indigo8: 'hsla(247,77%,44%,1)',
    indigo9: 'hsla(251,84%,36%,1)',
    indigo10: 'hsla(254,86%,28%,1)',
    indigoAlt1: 'hsla(236,100%,99%,1)',
    blue1: 'hsla(200,100%,97%,1)',
    blue2: 'hsla(202,100%,94%,1)',
    blue3: 'hsla(204,97%,86%,1)',
    blue4: 'hsla(206,93%,73%,1)',
    blue5: 'hsla(208,88%,62%,1)',
    blue6: 'hsla(210,83%,53%,1)',
    blue7: 'hsla(212,92%,43%,1)',
    blue8: 'hsla(214,95%,36%,1)',
    blue9: 'hsla(215,96%,32%,1)',
    blue10: 'hsla(216,98%,25%,1)',
    blueAlt1: 'hsla(200,100%,98%,1)',
    cyan1: 'hsla(186,100%,97%,1)',
    cyan2: 'hsla(186,100%,94%,1)',
    cyan3: 'hsla(185,94%,87%,1)',
    cyan4: 'hsla(184,80%,74%,1)',
    cyan5: 'hsla(185,68%,57%,1)',
    cyan6: 'hsla(185,62%,45%,1)',
    cyan7: 'hsla(184,77%,34%,1)',
    cyan8: 'hsla(185,81%,29%,1)',
    cyan9: 'hsla(185,84%,25%,1)',
    cyan10: 'hsla(184,91%,17%,1)',
    cyanAlt1: 'hsla(187,100%,98%,1)',
    green1: 'hsla(125,73%,97%,1)',
    green2: 'hsla(125,65%,93%,1)',
    green3: 'hsla(126,49%,84%,1)',
    green4: 'hsla(122,42%,75%,1)',
    green5: 'hsla(123,38%,63%,1)',
    green6: 'hsla(123,35%,51%,1)',
    green7: 'hsla(122,39%,41%,1)',
    green8: 'hsla(122,47%,35%,1)',
    green9: 'hsla(125,56%,29%,1)',
    green10: 'hsla(125,73%,20%,1)',
    greenAlt1: 'hsla(129,79%,98%,1)',
    red1: 'hsla(360,100%,98%,1)',
    red2: 'hsla(360,100%,95%,1)',
    red3: 'hsla(360,100%,87%,1)',
    red4: 'hsla(360,100%,80%,1)',
    red5: 'hsla(360,91%,69%,1)',
    red6: 'hsla(360,83%,62%,1)',
    red7: 'hsla(356,75%,53%,1)',
    red8: 'hsla(354,85%,44%,1)',
    red9: 'hsla(352,90%,35%,1)',
    red10: 'hsla(350,94%,28%,1)',
    redAlt1: 'hsla(360,100%,99%,1)',
    orange1: 'hsla(25,100%,97%,1)',
    orange2: 'hsla(24,100%,93%,1)',
    orange3: 'hsla(22,100%,85%,1)',
    orange4: 'hsla(20,100%,77%,1)',
    orange5: 'hsla(18,99%,70%,1)',
    orange6: 'hsla(16,94%,61%,1)',
    orange7: 'hsla(14,89%,55%,1)',
    orange8: 'hsla(12,87%,47%,1)',
    orange9: 'hsla(10,93%,40%,1)',
    orange10: 'hsla(8,93%,35%,1)',
    orangeAlt1: 'hsla(27,100%,98%,1)',
    yellow1: 'hsla(45,100%,97%,1)',
    yellow2: 'hsla(45,100%,94%,1)',
    yellow3: 'hsla(45,90%,88%,1)',
    yellow4: 'hsla(45,86%,81%,1)',
    yellow5: 'hsla(43,90%,76%,1)',
    yellow6: 'hsla(43,89%,70%,1)',
    yellow7: 'hsla(42,78%,60%,1)',
    yellow8: 'hsla(42,63%,48%,1)',
    yellow9: 'hsla(43,72%,37%,1)',
    yellow10: 'hsla(43,77%,27%,1)',
    yellowAlt1: 'hsla(45,100%,98%,1)',
    neutral1: 'hsla(216,40%,98%,1)',
    neutral2: 'hsla(216,34%,96%,1)',
    neutral3: 'hsla(214,23%,91%,1)',
    neutral4: 'hsla(210,16%,82%,1)',
    neutral5: 'hsla(211,13%,65%,1)',
    neutral6: 'hsla(211,10%,53%,1)',
    neutral7: 'hsla(211,12%,43%,1)',
    neutral8: 'hsla(209,18%,30%,1)',
    neutral9: 'hsla(209,22%,22%,1)',
    neutral10: 'hsla(210,24%,16%,1)',
    neutralAlt1: 'hsla(216,40%,99%,1)'
};
//# sourceMappingURL=palette.js.map